import _ from 'lodash'
import { Button, Col, Form, Input, Modal, Row, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { nanoid } from 'nanoid'
import Webcam from 'react-webcam'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { saveImage } from '../../../../shared/restClient'

const ParticipantModal = (props) => {
  const [initialValues, setInitialValues] = useState()
  const [imageUrl, setImageUrl] = useState()
  const [saveImageUrl, setSaveImageUrl] = useState()
  const [isWebcamVisible, setIsWebcamVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setInitialValues(props.participant)
    setImageUrl(props?.participant?.image)
    console.log(props.participant)
  }, [props.participant])

  const onFinish = (values) => {
    if (_.isEmpty(initialValues)) {
      values.uuid = nanoid()
      values.presence = false
    } else {
      values.uuid = props.participant.uuid
      values.presence = props.participant.presence
    }

    values.image = saveImageUrl
    props.saveParticipant(values)

    setImageUrl(undefined)
    setSaveImageUrl(undefined)
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  const handleCancel = () => {
    props.setAddParticipantVisible(false)
  }

  const getBase64 = (img, callback) => {
    const reader = new window.FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const onChange = async (info) => {
    console.log(info)
    // let src = info.file.url
    // if (info.fileList.length > 0) {
    //   src = await new Promise((resolve) => {
    //     const reader = new window.FileReader()
    //     reader.readAsDataURL(info.file)
    //     reader.onload = () => resolve(reader.result)
    //   })
    // }
    // setImageUrl(src)
    // setFileList(info.fileList)
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false)
        setImageUrl(url)
      })
    }
  }

  const handleCancelCamera = () => {
    setIsWebcamVisible(!isWebcamVisible)
  }

  const validateUpload = async (file) => {
    const data = await saveImage(props.uuid, file)

    console.log(data.filename)
    setSaveImageUrl(data.filename)
    return data.filename
  }

  return (
    <Modal title='Participant' visible={props.isAddParticipantVisible} onCancel={handleCancel} maskClosable={false} destroyOnClose footer={null}>
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
        initialValues={initialValues}
      >
        <Form.Item label='Fighter ID #' name='fid'>
          <Input placeholder='discord / gmail address' />
        </Form.Item>
        <Form.Item
          label='First Name'
          name='first_name'
          rules={[
            {
              required: true,
              message: 'Please input a first name!'
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Last Name'
          name='last_name'
          rules={[
            {
              required: true,
              message: 'Please input a last name!'
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label='Age' name='age'>
          <Input />
        </Form.Item>
        <Form.Item label='Demographic' name='demographic'>
          <Select>
            <Select.Option key='open' value='open'>Open</Select.Option>
            <Select.Option key='ladies' value='ladies'>Ladies</Select.Option>
            <Select.Option key='cadet' value='cadet'>Cadet</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label='Club' name='club'>
          <Input />
        </Form.Item>
        <Form.Item label='Rating' name='rating' initialValue='U'>
          <Select>
            <Select.Option key='U' value='U'>Unrated</Select.Option>
            <Select.Option key='E' value='E'>E</Select.Option>
            <Select.Option key='D' value='D'>D</Select.Option>
            <Select.Option key='C' value='C'>C</Select.Option>
            <Select.Option key='B' value='B'>B</Select.Option>
            <Select.Option key='A' value='A'>A</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label='Picture' name='image'>
          <Upload
            customRequest={({ file, onSuccess }) => {
              validateUpload(file).then((url) => {
                setLoading(false)
                setImageUrl(url)
              })
            }}
            listType='picture-card'
            maxCount={1}
            onChange={onChange}
            showUploadList={false}
          >
            {imageUrl
              ? (
                <img
                  className='here'
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%'
                  }}
                />
                )
              : (
                <div>
                  {loading ? <LoadingOutlined /> : <PlusOutlined />}
                  <div style={{
                    marginTop: 8
                  }}
                  >
                    Select
                  </div>
                </div>
                )}

          </Upload>
          <Button onClick={() => { setIsWebcamVisible(true) }}>Take</Button>
          <Modal title='Camera' visible={isWebcamVisible} maskClosable={false} onCancel={handleCancelCamera} destroyOnClose footer={null}>
            <Webcam width={470} screenshotFormat='image/jpeg'>
              {({ getScreenshot }) => (
                <button
                  onClick={async () => {
                    const img = getScreenshot()
                    const file = await (await fetch(img)).blob()
                    const data = await saveImage(props.uuid, file)
                    setImageUrl(img)
                    setSaveImageUrl(data.filename)
                    handleCancelCamera()
                  }}
                >
                  Capture photo
                </button>
              )}
            </Webcam>

          </Modal>
        </Form.Item>
        <Row className='tournament-control-area'>
          <Col span={24}>
            <Form.Item style={{ float: 'right', whiteSpace: 'nowrap' }}>
              <Button type='primary' htmlType='submit'>
                Save
              </Button>
              <Button htmlType='button' onClick={handleCancel}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default ParticipantModal
